<!-- SimpleNavigation：2020/4/20 Vue: ^2.5.2 YuAng-->

<template>
  <ts-iclass-header-simple  :site="site" :title="title" :back-url="site"></ts-iclass-header-simple>
</template>

<script>

export default {
  name: 'SimpleNavigation',
  components: {},
  props: {
    title: {
      type: String,
      default: function () {
        return '开心每一天'
      }
    }
  },
  computed : {
    site: function () {
      let official =  location.href.indexOf('gw=true') !== -1
      if (official) {
        return location.origin + '/official'
      } else {
        return location.origin
      }
    }
  }
}
</script>

<style scoped>
  .its-simple-navigation {
    height: 80px;
    background: white;
    padding: 0 calc((100% - 1200px) * 0.5);
  }
  .simple-navigation-left {
    float: left;
    width: 424px;
    text-align: center;
  }

  .simple-navigation-left .its-navigation-logo {
     height: 100%;
     display: inline-block;
     margin: 12px 0;
     float: left;
  }

  .simple-navigation-left > span {
    font-size: 18px;
    height: 100%;
    margin: 46px 0 0 16px;
    float: left;
    font-weight: 400;
  }

  .simple-navigation-right {
    float: right;
    width: 424px;
    text-align: right;
  }

  .simple-navigation-right > span {
    font-size: 18px;
    height: 100%;
    display: inline-block;
    cursor: pointer;
    margin-top:46px;
    font-weight: 400;
  }

  .simple-navigation-right > span:hover {
    color: #5591fe;
  }
</style>
